<template>
  <div>
    <transition name="fade" mode="out-in">
      <div v-if="!src" class="text-center">
        <i class="fas fa-spinner fa-spin fa-4x p-5 text-muted" />
      </div>

      <div
        v-else
        class="position-relative min-h-100px d-flex flex-column align-items-center justify-content-center"
      >
        <img
          :src="src"
          :alt="live.name"
          style="max-height: 250px; max-width: 100%"
        />
        <i
          class="fad fa-4x fa-play-circle text-primary position-absolute"
          style="top: 32%; left: 42%"
        ></i>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "LiveImage",
  props: {
    live: Object
  },
  data() {
    return {
      interval: null,
      src: ""
    };
  },
  mounted() {
    this.src = `https://play.mirol.ir/live/${this.live.program.slug}/index.png`;
    this.interval = setInterval(() => {
      this.src =
        `https://play.mirol.ir/live/${this.live.program.slug}/index.png?rnd=` +
        Math.random();
    }, 30000);
  },
  destroyed() {
    clearInterval(this.interval);
    this.interval = null;
  }
};
</script>
